<template>
  <div v-show="isShow.isPOShow" class="pageOne slideIn">
    <section class="canvas-container" id="canvas-container"></section>
    <section class="controller" ref="controllerEle" :class="isFold ? 'contentsFold' : 'contentsNotFold'">
      <nav class="nav">
        <div class="tab-item" @click="onSelectA" :class="isASelected ? 'tabSelected' : ''">
          <img src="./img/nav-place.png" alt="">
        </div>
        <div class="tab-item" @click="onSelectB" :class="isBSelected ? 'tabSelected' : ''">
          <img src="./img/nav-human.png" alt="">
        </div>
        <div class="tab-item" @click="onSelectC" :class="isCSelected ? 'tabSelected' : ''">
          <img src="./img/nav-dec.png" alt="">
        </div>
        <div class="tab-item" @click="onSelectD" :class="isDSelected ? 'tabSelected' : ''">
          <img src="./img/nav-pet.png" alt="">
        </div>
        <button class="btn-hide" :class="isFold ? 'reverse' : ''" @click="toggleFold">
          <img src="./img/nav-arrow.png" alt="">
        </button>
        <button class="btn-gen" @click="genPoster">
          <img src="./img/btn-generate.png" alt="">
        </button>
      </nav>
      <section class="contents">
        <div class="content-wrapper content-a-wrapper" :class="isASelected ? '' : 'hideContent'">
          <ul>
            <li class="sc-item" @click="changeScene(1)">
              <img src="./img/thumb-s1.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(2)">
              <img src="./img/thumb-s2.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(3)">
              <img src="./img/thumb-s3.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(4)">
              <img src="./img/thumb-s4.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(5)">
              <img src="./img/thumb-s5.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(6)">
              <img src="./img/thumb-s6.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(7)">
              <img src="./img/thumb-s7.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(8)">
              <img src="./img/thumb-s8.jpg" alt="">
            </li>
            <li class="sc-item" @click="changeScene(9)">
              <img src="./img/thumb-s9.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="content-wrapper content-b-wrapper" :class="isBSelected ? '' : 'hideContent'">
          <ul>
            <li class="hm-item" @click="showSidebar('Bgr')">
              <img src="./img/thumb-hm1.png" alt="">
            </li>
            <li class="hm-item" @click="showSidebar('B')">
              <img src="./img/thumb-hm2.png" alt="">
            </li>
            <li class="hm-item" @click="showSidebar('Cm')">
              <img src="./img/thumb-hm3.png" alt="">
            </li>
            <li class="hm-item" @click="showSidebar('Bmm')">
              <img src="./img/thumb-hm4.png" alt="">
            </li>
            <li class="hm-item" @click="showSidebar('Bm')">
              <img src="./img/thumb-hm5.png" alt="">
            </li>
            <li class="hm-item" @click="showSidebar('Cf')">
              <img src="./img/thumb-hm6.png" alt="">
            </li>
          </ul>
        </div>
        <div class="content-wrapper content-c-wrapper" :class="isCSelected ? '' : 'hideContent'">
          <ul>
            <li class="dec-item" @click="addEle('dec1')">
              <img src="./img/thumb-d1.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec2')">
              <img src="./img/thumb-d2.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec3')">
              <img src="./img/thumb-d3.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec4')">
              <img src="./img/thumb-d4.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec5')">
              <img src="./img/thumb-d5.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec6')">
              <img src="./img/thumb-d6.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec7')">
              <img src="./img/thumb-d7.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec8')">
              <img src="./img/thumb-d8.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec9')">
              <img src="./img/thumb-d9.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec10')">
              <img src="./img/thumb-d10.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec11')">
              <img src="./img/thumb-d11.png" alt="">
            </li>
            <li class="dec-item" @click="addEle('dec12')">
              <img src="./img/thumb-d12.png" alt="">
            </li>
          </ul>
        </div>
        <div class="content-wrapper content-d-wrapper" :class="isDSelected ? '' : 'hideContent'">
          <ul>
            <li class="pt-item" @click="addEle('pet1')">
              <img src="./img/thumb-p1.png" alt="">
            </li>
            <li class="pt-item" @click="addEle('pet2')">
              <img src="./img/thumb-p2.png" alt="">
            </li>
            <li class="pt-item" @click="addEle('pet3')">
              <img src="./img/thumb-p3.png" alt="">
            </li>
            <li class="pt-item" @click="addEle('pet4')">
              <img src="./img/thumb-p4.png" alt="">
            </li>
            <li class="pt-item" @click="addEle('pet5')">
              <img src="./img/thumb-p5.png" alt="">
            </li>
            <li class="pt-item" @click="addEle('pet6')">
              <img src="./img/thumb-p6.png" alt="">
            </li>
          </ul>
        </div>
      </section>
    </section>
    <aside class="sidebar" :class="isSidebarShow ? 'sidebarShow' : 'sidebarNotShow'">
      <div class="thumb-wrapper" v-show="isBgrShow">
        <ul>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH1')">
            <img src="./img/thumb-bg-hair1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH2')">
            <img src="./img/thumb-bg-hair2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH3')">
            <img src="./img/thumb-bg-hair3.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH4')">
            <img src="./img/thumb-bg-hair4.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH5')">
            <img src="./img/thumb-bg-hair5.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrHair('bgrH6')">
            <img src="./img/thumb-bg-hair6.png" alt="">
          </li>
        </ul>
        <ul>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC1')">
            <img src="./img/thumb-bg-clothes1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC2')">
            <img src="./img/thumb-bg-clothes2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC3')">
            <img src="./img/thumb-bg-clothes3.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC4')">
            <img src="./img/thumb-bg-clothes4.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC5')">
            <img src="./img/thumb-bg-clothes5.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBgrClo('bgrC6')">
            <img src="./img/thumb-bg-clothes6.png" alt="">
          </li>
        </ul>
      </div>
      <div class="thumb-wrapper" v-show="isBShow">
        <ul>
          <li class="thumb-img-wrapper" @click="changeBHair('bH1')">
            <img src="./img/thumb-b-hair1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBHair('bH2')">
            <img src="./img/thumb-b-hair2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBHair('bH3')">
            <img src="./img/thumb-b-hair3.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBHair('bH4')">
            <img src="./img/thumb-b-hair4.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBHair('bH5')">
            <img src="./img/thumb-b-hair5.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBHair('bH6')">
            <img src="./img/thumb-b-hair6.png" alt="">
          </li>
        </ul>
        <ul>
          <li class="thumb-img-wrapper" @click="changeBClo('bC1')">
            <img src="./img/thumb-b-clothes1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBClo('bC2')">
            <img src="./img/thumb-b-clothes2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBClo('bC3')">
            <img src="./img/thumb-b-clothes3.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBClo('bC4')">
            <img src="./img/thumb-b-clothes4.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBClo('bC5')">
            <img src="./img/thumb-b-clothes5.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="changeBClo('bC6')">
            <img src="./img/thumb-b-clothes6.png" alt="">
          </li>
        </ul>
      </div>
      <div class="thumb-wrapper" v-show="isCmShow">
        <ul>
          <li class="thumb-img-wrapper" @click="addSubPerson('cm1')">
            <img src="./img/thumb-chm1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('cm2')">
            <img src="./img/thumb-chm2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('cm3')">
            <img src="./img/thumb-chm3.png" alt="">
          </li>
        </ul>
      </div>
      <div class="thumb-wrapper" v-show="isCfShow">
        <ul>
          <li class="thumb-img-wrapper" @click="addSubPerson('cf1')">
            <img src="./img/thumb-chf1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('cf2')">
            <img src="./img/thumb-chf2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('cf3')">
            <img src="./img/thumb-chf3.png" alt="">
          </li>
        </ul>
      </div>
      <div class="thumb-wrapper" v-show="isBmmShow">
        <ul>
          <li class="thumb-img-wrapper" @click="addSubPerson('bmm1')">
            <img src="./img/thumb-bmm1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('bmm2')">
            <img src="./img/thumb-bmm2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('bmm3')">
            <img src="./img/thumb-bmm3.png" alt="">
          </li>
        </ul>
      </div>
      <div class="thumb-wrapper" v-show="isBmShow">
        <ul>
          <li class="thumb-img-wrapper" @click="addSubPerson('bm1')">
            <img src="./img/thumb-bm1.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('bm2')">
            <img src="./img/thumb-bm2.png" alt="">
          </li>
          <li class="thumb-img-wrapper" @click="addSubPerson('bm3')">
            <img src="./img/thumb-bm3.png" alt="">
          </li>
        </ul>
      </div>
    </aside>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import { eleData } from './eleData.js';
import { descData } from './descData.js';

let Application = PIXI.Application;
let Sprite = PIXI.Sprite;

export default {
  name: 'PageOne',
  props: {
    isShow: {
      type: Object
    }
  },
  data() {
    return {
      mergedSrc: null,
      isBExist: false,
      isBgrExist: false,
      isSidebarShow: false,
      isBgrShow: false,
      isBShow: false,
      isBmmShow: false,
      isBmShow: false,
      isCmShow: false,
      isCfShow: false,
      isFold: false,
      isASelected: true,
      isBSelected: false,
      isCSelected: false,
      isDSelected: false,
      targetName: null,
      startPosition: null,
      isDragging: false,
      toBeResized: null,
      isResizingDrag: false,
      resizeScale: null,
      app: null,
      btnResize: require('./img/btn-resize.png'),
      btnDel: require('./img/btn-del.png'),
      bg1: require('./img/bg1.jpg'),
      bg2: require('./img/bg2.jpg'),
      bg3: require('./img/bg3.jpg'),
      bg4: require('./img/bg4.jpg'),
      bg5: require('./img/bg5.jpg'),
      bg6: require('./img/bg6.jpg'),
      bg7: require('./img/bg7.jpg'),
      bg8: require('./img/bg8.jpg'),
      bg9: require('./img/bg9.jpg'),
      pet1: require('./img/pet1.png'),
      pet2: require('./img/pet2.png'),
      pet3: require('./img/pet3.png'),
      pet4: require('./img/pet4.png'),
      pet5: require('./img/pet5.png'),
      pet6: require('./img/pet6.png'),
      dec1: require('./img/dec1.png'),
      dec2: require('./img/dec2.png'),
      dec3: require('./img/dec3.png'),
      dec4: require('./img/dec4.png'),
      dec5: require('./img/dec5.png'),
      dec6: require('./img/dec6.png'),
      dec7: require('./img/dec7.png'),
      dec8: require('./img/dec8.png'),
      dec9: require('./img/dec9.png'),
      dec10: require('./img/dec10.png'),
      dec11: require('./img/dec11.png'),
      dec12: require('./img/dec12.png'),
      bmm1: require('./img/bmm1.png'),
      bmm2: require('./img/bmm2.png'),
      bmm3: require('./img/bmm3.png'),
      bm1: require('./img/bm1.png'),
      bm2: require('./img/bm2.png'),
      bm3: require('./img/bm3.png'),
      cf1: require('./img/cf1.png'),
      cf2: require('./img/cf2.png'),
      cf3: require('./img/cf3.png'),
      cm1: require('./img/cm1.png'),
      cm2: require('./img/cm2.png'),
      cm3: require('./img/cm3.png'),
      bgrHead: require('./img/bridegroom-face.png'),
      bHead: require('./img/bride-face.png'),
      bgrH1: require('./img/bg-hair1.png'),
      bgrH2: require('./img/bg-hair2.png'),
      bgrH3: require('./img/bg-hair3.png'),
      bgrH4: require('./img/bg-hair4.png'),
      bgrH5: require('./img/bg-hair5.png'),
      bgrH6: require('./img/bg-hair6.png'),
      bgrC1: require('./img/bg-clothes1.png'),
      bgrC2: require('./img/bg-clothes2.png'),
      bgrC3: require('./img/bg-clothes3.png'),
      bgrC4: require('./img/bg-clothes4.png'),
      bgrC5: require('./img/bg-clothes5.png'),
      bgrC6: require('./img/bg-clothes6.png'),
      bH1: require('./img/b-hair1.png'),
      bH2: require('./img/b-hair2.png'),
      bH3: require('./img/b-hair3.png'),
      bH4: require('./img/b-hair4.png'),
      bH5: require('./img/b-hair5.png'),
      bH6: require('./img/b-hair6.png'),
      bC1: require('./img/b-clothes1.png'),
      bC2: require('./img/b-clothes2.png'),
      bC3: require('./img/b-clothes3.png'),
      bC4: require('./img/b-clothes4.png'),
      bC5: require('./img/b-clothes5.png'),
      bC6: require('./img/b-clothes6.png'),
      txtImg: require('./img/fn-desc.png')
    }
  },
  computed: {
    // isSidebarShow() {
    //   return this.isBgrShow || this.isBShow || this.isBmmShow || this.isBmShow || this.isCfShow || this.isCmShow;
    // }
  },
  methods: {
    showNext () {
      this.isShow.isPTShow = true
      this.isShow.isPOShow = false
    },
    showSidebar(name) {
      this.clearOutline();
      if (name === 'Bgr') {
        this.addBgrPerson();
        this.targetName = 'bgr';
      }
      if (name === 'B') {
        this.addBPerson();
        this.targetName = 'b';
      }
      const condition = this.isBgrShow || this.isBShow || this.isCfShow || this.isCmShow || this.isBmmShow || this.isBmShow;
      if (condition) {
        this.hideSidebarAllSimple();
      }
      this.isSidebarShow = true;
      this[`is${name}Show`] = true;
    },
    hideSidebarAllSimple() {
      this.isBgrShow = false;
      this.isBShow = false;
      this.isCfShow = false;
      this.isCmShow = false;
      this.isBmmShow = false;
      this.isBmShow = false;
    },
    hideSidebarAll() {
      this.isSidebarShow = false;
      setTimeout(() => {
        this.isBgrShow = false;
        this.isBShow = false;
        this.isCmShow = false;
        this.isCfShow = false;
        this.isBmShow = false;
        this.isBmmShow = false;
      }, 400);
    },
    toggleFold() {
      this.isFold = !this.isFold;
    },
    onSelectA() {
      this.isASelected = true;
      this.isBSelected = false;
      this.isCSelected = false;
      this.isDSelected = false;
      this.isFold = false;
      this.hideSidebarAll();
    },
    onSelectB() {
      this.isASelected = false;
      this.isBSelected = true;
      this.isCSelected = false;
      this.isDSelected = false;
      this.isFold = false;
      this.hideSidebarAll();
    },
    onSelectC() {
      this.isASelected = false;
      this.isBSelected = false;
      this.isCSelected = true;
      this.isDSelected = false;
      this.isFold = false;
      this.hideSidebarAll();
    },
    onSelectD() {
      this.isASelected = false;
      this.isBSelected = false;
      this.isCSelected = false;
      this.isDSelected = true;
      this.isFold = false;
      this.hideSidebarAll();
    },
    init() {
      let app = new Application({
        width: 750,
        height: 1334,
        antialias: true,
        transparent: true,
        resolution: 1
      });

      const myCanvas = document.getElementById('canvas-container');
      myCanvas.appendChild(app.view);

      let bgSpr = new Sprite.fromImage(this.bg1);
      bgSpr.width = 750;
      bgSpr.height = 1334;
      bgSpr.position.set(0, 0);
      bgSpr.name = 'bg';
      bgSpr.interactive = true;
      bgSpr.on('tap', () => {
        this.hideSidebarAll();
        this.clearOutline();
      });

      app.stage.addChild(bgSpr);
      this.app = app;
    },
    changeScene(num) {
      const bgSpr = new Sprite.fromImage(this[`bg${num}`]);
      bgSpr.width = 750;
      bgSpr.height = 1334;
      bgSpr.position.set(0, 0);
      bgSpr.name = 'bg';
      bgSpr.interactive = true;
      bgSpr.on('tap', () => {
        this.hideSidebarAll();
        this.clearOutline();
      });

      this.app.stage.removeChildAt(0);
      this.app.stage.addChild(bgSpr);
      this.app.stage.setChildIndex(bgSpr, 0);
    },
    addEle(name = 'pet1') {
      this.clearOutline();
      let givenName = name + Math.random().toString(36).substring(7);
      const originalPos = this.setOriginalPos();
      const {w, h} = eleData[name];

      const container = new PIXI.Container();
      container.x = originalPos.x;
      container.y = originalPos.y;
      container.interactive = true;
      container.name = givenName;
      this.targetName = givenName;

      const eleSpr = new Sprite.fromImage(this[`${name}`]);
      eleSpr.width = w;
      eleSpr.height = h;
      eleSpr.anchor.set(.5, .5);
      eleSpr.name = `${name}Spr`;

      container.addChild(eleSpr);
      this.addController(container, w, h);
      this.app.stage.addChild(container);
    },
    addSubPerson(name = 'cm1') {
      this.clearOutline();
      let givenName = name + Math.random().toString(36).substring(7);
      const originalPos = this.setOriginalPos();
      const {w, h} = eleData[name];

      const container = new PIXI.Container();
      container.x = originalPos.x;
      container.y = originalPos.y;
      container.interactive = true;
      container.name = givenName;
      this.targetName = givenName;

      const eleSpr = new Sprite.fromImage(this[`${name}`]);
      eleSpr.width = w;
      eleSpr.height = h;
      eleSpr.anchor.set(.5, .5);
      eleSpr.name = `${name}Spr`;

      container.addChild(eleSpr);
      this.addController(container, w, h);
      this.app.stage.addChild(container);
    },
    addBgrPerson() {
      this.clearOutline();
      if (!this.isBgrExist) {
        let givenName = 'bgr'
        this.targetName = givenName;

        const originPos = this.setOriginalPos();
        const {w: headW, h: headH} = eleData.bgrHead;
        const {w: cloW, h: cloH} = eleData.bgrC1;
        const {w: hairW, h: hairH} = eleData.bgrH1;

        const container = new PIXI.Container();
        container.x = originPos.x;
        container.y = originPos.y;
        container.interactive = true;
        container.name = givenName;

        const clothesSpr = new Sprite.fromImage(this.bgrC1);
        clothesSpr.width = cloW;
        clothesSpr.height = cloH;
        clothesSpr.anchor.set(.5, .5);
        clothesSpr.position.set(0, 55);
        clothesSpr.name = 'bgrC1';

        const headSpr = new Sprite.fromImage(this.bgrHead);
        headSpr.width = headW;
        headSpr.height = headH;
        headSpr.anchor.set(.5, .5);
        headSpr.position.set(25, -200);
        headSpr.name = 'bgrHead';

        const hairSpr = new Sprite.fromImage(this.bgrH1);
        hairSpr.width = hairW;
        hairSpr.height = hairH;
        hairSpr.anchor.set(.5, .5);
        hairSpr.position.set(25, -232);
        hairSpr.name = 'bgrH1';

        container.addChild(clothesSpr);
        container.addChild(headSpr);
        container.addChild(hairSpr);
        this.addController(container, container.width, container.height);
        this.app.stage.addChild(container);

        this.isBgrExist = true;
      } else {
        this.getSelectedContainer('bgr');
      }
    },
    changeBgrHair(name = 'bgrH1') {
      const {w, h} = eleData[name];

      const curContainer = this.app.stage.getChildByName(this.targetName);
      const curHair = curContainer.getChildAt(2);
      curContainer.removeChild(curHair);

      const hairSpr = new Sprite.fromImage(this[name]);
      hairSpr.width = w;
      hairSpr.height = h;
      hairSpr.anchor.set(.5, .5);
      hairSpr.position.set(25, -232);
      hairSpr.name = name;

      curContainer.addChildAt(hairSpr, 2);
    },
    changeBgrClo(name = 'bgrC1') {
      const {w, h} = eleData[name];

      const curContainer = this.app.stage.getChildByName(this.targetName);
      const curClo = curContainer.getChildAt(0);
      curContainer.removeChild(curClo);

      const cloSpr = new Sprite.fromImage(this[name]);
      cloSpr.width = w;
      cloSpr.height = h;
      cloSpr.anchor.set(.5, .5);
      cloSpr.position.set(0, 55);
      cloSpr.name = name;

      curContainer.addChildAt(cloSpr, 0);
    },
    addBPerson() {
      this.clearOutline();
      if (!this.isBExist) {
        let givenName = 'b'
        this.targetName = givenName;

        const originPos = this.setOriginalPos();
        const {w: headW, h: headH} = eleData.bHead;
        const {w: cloW, h: cloH} = eleData.bC1;
        const {w: hairW, h: hairH} = eleData.bH1;

        const container = new PIXI.Container();
        container.x = originPos.x;
        container.y = originPos.y;
        container.interactive = true;
        container.name = givenName;

        const clothesSpr = new Sprite.fromImage(this.bC1);
        clothesSpr.width = cloW;
        clothesSpr.height = cloH;
        clothesSpr.anchor.set(.5, .5);
        clothesSpr.position.set(18, 75);
        clothesSpr.name = 'bC1';

        const headSpr = new Sprite.fromImage(this.bHead);
        headSpr.width = headW;
        headSpr.height = headH;
        headSpr.anchor.set(.5, .5);
        headSpr.position.set(0, -200);
        headSpr.name = 'bHead';

        const hairSpr = new Sprite.fromImage(this.bH1);
        hairSpr.width = hairW;
        hairSpr.height = hairH;
        hairSpr.anchor.set(.5, .5);
        hairSpr.position.set(0, -170);
        hairSpr.name = 'bH1';

        container.addChild(clothesSpr);
        container.addChild(headSpr);
        container.addChild(hairSpr);
        this.addController(container, container.width - 40, container.height - 30);
        this.app.stage.addChild(container);

        this.isBExist = true;
      } else {
        this.getSelectedContainer('b');
      }
    },
    changeBHair(name = 'bH1') {
      const {w, h} = eleData[name];

      const curContainer = this.app.stage.getChildByName(this.targetName);
      const curHair = curContainer.getChildAt(2);
      curContainer.removeChild(curHair);

      const hairSpr = new Sprite.fromImage(this[name]);
      hairSpr.width = w;
      hairSpr.height = h;
      hairSpr.anchor.set(.5, .5);
      hairSpr.position.set(0, -170);
      hairSpr.name = name;

      curContainer.addChildAt(hairSpr, 2);
    },
    changeBClo(name = 'bC1') {
      const {w, h} = eleData[name];

      const curContainer = this.app.stage.getChildByName(this.targetName);
      const curClo = curContainer.getChildAt(0);
      curContainer.removeChild(curClo);

      const cloSpr = new Sprite.fromImage(this[name]);
      cloSpr.width = w;
      cloSpr.height = h;
      cloSpr.anchor.set(.5, .5);
      cloSpr.position.set(18, 75);
      cloSpr.name = name;

      curContainer.addChildAt(cloSpr, 0);
    },
    setOriginalPos() {
      const random = Math.random() * 40;
      const posX = 750 / 2 + random;
      const posY = 1334 / 2 + random;
      return {
        x: posX,
        y: posY
      }
    },
    getSelectedContainer(name) {
      const curContainer = this.app.stage.getChildByName(name);
      let lastChildIndex = curContainer.children.length - 1;
      curContainer.children[lastChildIndex].visible = true;
      curContainer.children[lastChildIndex - 1].visible = true;
      curContainer.children[lastChildIndex - 2].visible = true;
      return curContainer;
    },
    getStageHeight() {
      let windowHeight = window.innerHeight;
      let ele = this.$refs.controllerEle;
      let controllerHeight = window.getComputedStyle(ele).height;
      let realHeight = parseInt(controllerHeight.replace(/[a-z]+/g, ''));
      return windowHeight - realHeight
    },
    clearOutline() {
      const children = this.app.stage.children;
      const modifiedChildren = children.slice(1);
      const len = modifiedChildren.length;
      for (let i = 0; i < len; i++) {
        const lastChildIndex = modifiedChildren[i].children.length - 1;
        modifiedChildren[i].children[lastChildIndex].visible = false;
        modifiedChildren[i].children[lastChildIndex - 1].visible = false;
        modifiedChildren[i].children[lastChildIndex - 2].visible = false;
      }
    },
    addController(sprContainer, sprWidth, sprHeight) {
      // 添加叉号按钮
      const crossSpr = new Sprite.fromImage(this.btnDel);
      crossSpr.width = 40;
      crossSpr.height = 40;
      crossSpr.anchor.set(.5, .5);
      crossSpr.position.set(- sprWidth / 2 - 10, sprHeight / 2 + 10);
      crossSpr.interactive = true;
      crossSpr.name = 'crossBtn';

      // 添加缩放按钮
      const resizeSpr = new Sprite.fromImage(this.btnResize);
      resizeSpr.width = 40;
      resizeSpr.height = 40;
      resizeSpr.anchor.set(.5, .5);
      resizeSpr.position.set(sprWidth / 2 + 10, - sprHeight / 2 - 10);
      resizeSpr.interactive = true;
      resizeSpr.name = 'resizeBtn';

      // 添加隐藏操作
      crossSpr.on('tap', (evt) => {
        sprContainer.visible = false;
        if (evt.target.parent.name === 'bgr') {
          this.isBgrExist = false;
        }
        if (evt.target.parent.name === 'b') {
          this.isBExist = false;
        }
      });

      // 添加缩放操作
      resizeSpr.on('touchstart', (evt) => {
        if (evt.target.name === 'resizeBtn') {
          this.toBeResized = evt.target.parent;
          this.isResizingDrag = true;
          this.resizeScale = this.toBeResized.scale.x;

          this.startPosition = {
            x: evt.data.global.x,
            y: evt.data.global.y
          }
        }
      });

      resizeSpr.on('touchmove', (evt) => {
        if (this.isResizingDrag) {
          let newPosition = {
            x: evt.data.global.x,
            y: evt.data.global.y
          }
          let movedLength = newPosition.x - this.startPosition.x;
          this.startPosition.x = newPosition.x;

          if (movedLength < 0) {
            this.resizeScale -= 0.01;
            if (this.resizeScale < .4) {
              this.resizeScale = .4;
            }
          } else if (movedLength > 0) {
            this.resizeScale += 0.01;
            if (this.resizeScale > 2) {
              this.resizeScale = 2;
            }
          }
          this.toBeResized.scale.set(this.resizeScale, this.resizeScale);
        }
      });

      resizeSpr.on('touchendoutside', () => {
        this.isResizingDrag = false;
      });

      resizeSpr.on('touchend', () => {
        this.isResizingDrag = false;
      });

      // 添加容器的移动操作
      sprContainer.on('touchstart', (evt) => {
        if (!this.isResizingDrag) {
          this.targetName = evt.target.name;
          if (this.targetName !== 'crossBtn') {
            this.clearOutline();
            let curContainer = this.getSelectedContainer(this.targetName);
            if (curContainer !== undefined) {
              let len = this.app.stage.children.length - 1;
              this.app.stage.setChildIndex(curContainer, len);
            }
            if (this.targetName === 'bgr') {
              this.hideSidebarAllSimple();
              this.isSidebarShow = true;
              this.isBgrShow = true;
            } else if (this.targetName === 'b') {
              this.hideSidebarAllSimple();
              this.isSidebarShow = true;
              this.isBShow = true;
            } else {
              this.hideSidebarAll();
            }
            this.isDragging = true;
          }
        }
      });

      sprContainer.on('touchmove', (evt) => {
        // const stageHeight = this.getStageHeight() * 2;
        if (this.isDragging) {
          let posX = evt.data.global.x;
          let posY = evt.data.global.y;
          const curContainer = this.getSelectedContainer(this.targetName);
          const targetHeight = curContainer.height;
          const targetWidth = curContainer.width;
          const leftZone = targetWidth / 2;
          const upZone = targetHeight / 2;
          // const modY = stageHeight > 1090 ? (1090 - targetHeight / 2 + 30) : (stageHeight - targetHeight / 2 + 30);
          const modY = 1090 - targetHeight / 2 + 30;
          // X 坐标
          if (posX < leftZone) {
            curContainer.x = leftZone;
          } else if (posX >= leftZone && posX <= (750 - leftZone)) {
            curContainer.x = posX;
          } else {
            curContainer.x = 750 - leftZone;
          }
          // Y 坐标
          if (posY < upZone) {
            curContainer.y = upZone;
          } else if (posY >= upZone && posY <= modY) {
            curContainer.y = posY;
          } else {
            curContainer.y = modY;
          }
        }
      });

      sprContainer.on('touchend', () => {
        this.isDragging = false;
      });

      // 为精灵添加轮廓线
      let borderline = new PIXI.Graphics();
      borderline.lineStyle(2, 0xbfd7e3);
      borderline.drawRoundedRect(- sprWidth / 2 - 10, - sprHeight / 2 - 10, sprWidth + 20, sprHeight + 20, 10);
      borderline.endFill();

      sprContainer.addChild(borderline);
      sprContainer.addChild(resizeSpr);
      sprContainer.addChild(crossSpr);
    },
    genPoster() {
      this.addText();
      this.showNext();
    },
    addText() {
      this.clearOutline();

      const textSpr = new Sprite.fromImage(this.txtImg);
      textSpr.width = 750;
      textSpr.height = 244;
      textSpr.anchor.set(0, 1);
      textSpr.position.set(0, 1334);
      this.app.stage.addChild(textSpr);

      const textStyle = {
        fontFamily: ["PingFang SC", "Helvetica Neue", 'STHeiti', "Microsoft Yahei"],
        fontSize: '20px',
        letterSpacing: 2,
        fill: '#5e7091'
      }

      const textNum = Math.floor(Math.random() * 13) + 1;
      const text = new PIXI.Text(descData[`word${textNum}`], textStyle);
      text.anchor.set(0, .5);
      text.position.set(48, 1238);

      this.app.stage.addChild(text);

      setTimeout(() => {
        this.mergedSrc = this.app.renderer.plugins.extract.base64(this.app.stage);
      }, 400);
      setTimeout(() => {
        this.$emit('sendImg', this.mergedSrc);
      }, 600);
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="less" scoped>
.pageOne {
  height: 100%;
  background-color: #f9ede1;
  .contentsFold {
    transform: translateY(11.25rem);
  }
  .contentsNotFold {
    transform: translateY(0);
  }
  .controller {
    position: absolute;
    bottom: 0;
    width: 100%;
    transition: all .4s ease;
    .nav {
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 2.5rem /* 40/16 */;
      background-color: #ffffff;
      box-shadow: 0 -4px 5px 0 rgba(0,0,0,0.08), 0 -1px 10px 0 rgba(0,0,0,0.06), 0 -2px 4px -1px rgba(0,0,0,0.1);
      .tabSelected {
        background-color: #f6f6f6;
      }
      .tab-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .4s ease;
        img {
          width: 1.875rem /* 30/16 */;
          height: 1.875rem /* 30/16 */;
        }
      }
      .reverse {
        transform-origin: center;
        transform: rotate(180deg);
      }
      .btn-hide {
        flex: 1;
        background: transparent;
        border: unset;
        padding: unset;
        img {
          width: 1.875rem /* 30/16 */;
          height: 1.875rem /* 30/16 */;
        }
      }
      .btn-gen {
        position: absolute;
        right: 1.25rem /* 20/16 */;;
        top: -3.75rem /* 60/16 */;
        width: 2.5rem /* 40/16 */;
        height: 2.5rem /* 40/16 */;
        padding: unset;
        border: unset;
        background: transparent;
        border-radius: 50%;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
        img {
          width: 2.5rem /* 40/16 */;
          height: 2.5rem /* 40/16 */;
        }
      }
    }
    // .contentsFold {
    //   // transform: translateY(11.25rem);
    //   height: 0;
    // }
    // .contentsNotFold {
    //   // transform: translateY(0);
    //   height: 11.25rem;
    // }
    .contents {
      height: 11.25rem;
      background-color: #f6f6f6;
      transition: all .4s ease;
      .content-wrapper {
        width: 100%;
        height: 100%;
      }
      .content-a-wrapper {
        overflow-y: scroll;
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 4.375rem /* 70/16 */;
            height: 4.375rem /* 70/16 */;
            margin: .625rem /* 10/16 */;
            border-radius: 50%;
            overflow: hidden;
            img {
              width: 4.375rem /* 70/16 */;
              height: 4.375rem /* 70/16 */;
            }
          }
        }
      }
      .content-b-wrapper, .content-d-wrapper {
        padding: 0 1.25rem /* 20/16 */;
        box-sizing: border-box;
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 4.6875rem /* 75/16 */;
            height: 4.6875rem /* 75/16 */;
            margin: .5rem /* 8/16 */ .625rem /* 10/16 */;
            img {
              width: 4.6875rem /* 75/16 */;
              height: 4.6875rem /* 75/16 */;
            }
          }
        }
      }
      .content-c-wrapper {
        overflow-y: scroll;
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 3.75rem /* 60/16 */;
            height: 3.75rem /* 60/16 */;
            margin: .875rem /* 14/16 */;
            img {
              width: 3.75rem /* 60/16 */;
              height: 3.75rem /* 60/16 */;
            }
          }
        }
      }
    }
  }
  .sidebarShow {
    transform: translateX(0);
  }
  .sidebarNotShow {
    transform: translateX(120%);
  }
  .sidebar {
    position: absolute;
    top: 10%;
    right: 1rem;
    max-width: 6.875rem /* 110/16 */;
    transition: all .4s ease;
    .thumb-wrapper {
      display: flex;
      justify-content: space-between;
      ul {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin: 0 .25rem /* 4/16 */;
        .thumb-img-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2.875rem /* 46/16 */;
          height: 2.875rem /* 46/16 */;
          margin: .25rem /* 4/16 */ 0;
          background-color: rgba(255, 255, 255, .8);
          border-radius: .5rem /* 8/16 */;
          img {
            width: 2.5rem /* 40/16 */;
            height: 2.5rem /* 40/16 */;
          }
        }
      }
    }
  }
}

.hideContent {
  display: none;
  transition: all .2s ease;
}

.slideIn {
  animation: slideIn .4s ease-in;
  animation-fill-mode: both;
}

@keyframes slideIn {
  from {
    opacity: .2;
  }
  to {
    opacity: 1;
  }
}
</style>
